export default __webpack_public_path__ + "static/media/banner_order-food.672d1538.jpg";